export default __webpack_public_path__ + "static/meds-9d60002576440a250a7fadf9e18ab40e.svg";